import { createFileRoute } from "@tanstack/react-router";
import { LivePortalPage } from "@/components/shared/LivePortalPage";
export const Route = createFileRoute("/portal.notifications")({
  component: Page,
});
function Page() {
  return (
    <LivePortalPage
      title="Notifications"
      description="Live data from your KIZAK account."
      table="notifications"
      filterField="user_id"
      columns={[
        { key: "title", label: "Title" },
        { key: "body", label: "Message" },
        { key: "read_at", label: "Read" },
      ]}
    />
  );
}
